import { CellModelDisplayMode, } from "./cell-model.types";
import { DialogStatus } from "shared/types";
const cellModelState = {
    inUse: false,
    state: null,
    variablesList: null,
    populationNames: [],
    dynamicNames: [],
    dynamicDialogStatus: DialogStatus.CLOSED,
    dependencyDialogStatus: DialogStatus.CLOSED,
    variableEffectDialogStatus: DialogStatus.CLOSED,
    populationEffectDialogStatus: DialogStatus.CLOSED,
    refineDialogStatus: DialogStatus.CLOSED,
    createRefinedCellModelDialogStatus: DialogStatus.CLOSED,
    currentDynamicId: null,
    currentPopulationId: null,
    editingPopulationId: null,
    addingPopulation: false,
    dependencyVariableGraphData: null,
    refinementParameters: [],
    refined: false,
    highlightedMode: { isHighlight: false, node: null },
    displayMode: CellModelDisplayMode.PREVIEW,
};
export default cellModelState;
